import * as Scrivito from "scrivito";

const LinkTitle = Scrivito.connect(({ link }) => {
  if (link.title && link.title()) {
    return link.title();
  }

  if (link.isInternal && link.isInternal()) {
    return link.obj().get("title");
  }

  return (link.url && link.url()) || link.get("title");
});

export default LinkTitle;
